import { Link, useSearchParams } from "react-router-dom";
import { Card, Button } from "react-bootstrap";

export default function ForgotPasswordNext() {
  const handleResend = () => {
    // this should call a send email function
    console.log("resent");
  };

  const [searchParams] = useSearchParams();

  return (
    <>
      <Card.Title>Check your email!</Card.Title>
      <p className="subtitle">
        Please check the email address {searchParams.get("email")} for
        instructions to reset your password.
      </p>
      <Button onClick={handleResend} type="submit" className="sign-in-button">
        Resend Email
      </Button>
      <Link className="link" to="/">
        Back to login
      </Link>
    </>
  );
}
